import {
  resideoProductsAirLink,
  resideoSolutionsLink,
  resideoResourcesLink,
  resideoProPerksLink,
  resideoProMybusinessLink,
} from './externalLinks';

export interface PrimaryNavigationItem {
  name: string;
  linkTextKey: string;
  linkPath: string;
  isExternalLink?: boolean;
}

const primaryNavigation: PrimaryNavigationItem[] = [
  {
    name: 'products',
    linkTextKey: 'header.primary.products',
    linkPath: resideoProductsAirLink,
    isExternalLink: true,
  },
  {
    name: 'solutions',
    linkTextKey: 'header.primary.solutions',
    linkPath: resideoSolutionsLink,
    isExternalLink: true,
  },
  {
    name: 'resources',
    linkTextKey: 'header.primary.resources',
    linkPath: resideoResourcesLink,
    isExternalLink: true,
  },
  {
    name: 'perks',
    linkTextKey: 'header.primary.perks',
    linkPath: resideoProPerksLink,
    isExternalLink: true,
  },
  {
    name: 'mybusiness',
    linkTextKey: 'header.primary.mybusiness',
    linkPath: resideoProMybusinessLink,
    isExternalLink: true,
  },
];

export { primaryNavigation as default };
